import { Directive, ElementRef, Input } from '@angular/core';
import { Section } from '@miq/catalog';
import { columnNotFavoriteNotRequired } from './not-favorite-not-required';
import { VisibilityToggler } from './visibility-toggler';

@Directive({
  selector: '[miqShowFavoriteSection]',
  standalone: false,
})
export class ShowFavoriteSectionDirective extends VisibilityToggler<Section> {
  @Input('miqShowFavoriteSection') declare input: Section;

  constructor(protected el: ElementRef) {
    super(el);
  }

  shouldHide(favorites: { [key: number]: boolean }): boolean {
    return this.input.columns.every(col => columnNotFavoriteNotRequired(favorites, col));
  }
}
